import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

// COM-640 Task 2: formats the All Articles feed's `lastUpdatedAt` (backend
// `DatabaseService#getLastCheckedAt`, a project-wide `max(sources.last_checked_at)`
// - reversed 2026-08-19 from the original `max(article.created_at)`, see that
// method's doc comment) into ScanIndicator's idle "Last updated ..."
// label (Figma 2871:49860). `now` is injected (defaults to `new Date()`) so
// callers/tests never depend on the real wall clock - see
// relativeTime.test.ts.
//
// A future `iso` (clock skew between this client and whichever server
// stamped `created_at`) must not render as "in 2 minutes" - dayjs's
// `fromNow()` would do exactly that, which reads as broken to a user with no
// way to know the two clocks disagree. Clamped to `now` instead, so the
// worst case a future timestamp can produce is "a few seconds ago".
export function formatLastUpdated(iso: string | null, now: Date = new Date()): string {
  if (!iso) {
    return '';
  }

  const parsed = dayjs(iso);
  if (!parsed.isValid()) {
    return '';
  }

  const reference = dayjs(now);
  const clamped = parsed.isAfter(reference) ? reference : parsed;
  return `Last updated ${clamped.from(reference)}`;
}
